import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import { DateTime } from "luxon";

import { useNavigate } from "react-router-dom";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';

import { headers, filters, tabs } from "./config";

// for follow up
import useFollowUpSnackbarStore from "../../store/repair_follow_up";


import FileDownloader from "../../utils/FileDownloader";



const RepairTicketList = () => {

  const [loadingTickets, setLoadingTickets] = useState({}); // Loading state for the printing

  const showSnackbar = useFollowUpSnackbarStore(state => state.showSnackbar);
  const navigate = useNavigate();

  const scheduleFollowUp = (id, row) => {
    let eta;
    if (row?.status === "scheduled") {
      eta = DateTime.local().plus({days: row?.estimated_time_to_complete}).toLocaleString()
    } else if (row?.status === "completed") {
      eta = DateTime.local().toLocaleString()
    } else {
      eta = DateTime.fromISO(row?.accepted_at).plus({days: row?.estimated_time_to_complete}).toLocaleString();
    }
    showSnackbar({repair_id: row?.repair_ticket_id, repair_num: row?.repair_ticket_num, date: eta, customer_id: row?.customer_id, customer_name: row?.client_name, customer_phone: row?.customer_phone});
    navigate(`/calendar?view=timeline&date=${eta}`);
  }

  const downloadFile = async (repair_ticket_id) => {
    let fileDownloader = new FileDownloader();
    setLoadingTickets(prev => ({ ...prev, [repair_ticket_id]: true })); // Start loading
    try {
      await fileDownloader.downloadAndDisplayPdf(`/repair_tickets/generate/all_slips/${repair_ticket_id}`, "tickets", "", "application/pdf");
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingTickets(prev => ({ ...prev, [repair_ticket_id]: false }));
    }
  }

  const additionalActions = [
    {
      tooltip: "Schedule Follow Up",
      Icon: UpdateRoundedIcon,
      onClick: scheduleFollowUp,
      check: (row) => !row?.scheduled_appointment && row?.follow_up_service,
      color: "warning"
    },
    {
      tooltip: "Print Repair Tickets",
      Icon: PrintRoundedIcon,
      onClick: (id, row) => downloadFile(row?.repair_ticket_id),
      color: "success",
      isLoading: (row) => loadingTickets[row?.repair_ticket_id]
    },
  ]

  return (
    <Table tableId="repair_tickets" title="Repair Ticket" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-repair_ticket_num" idKey="repair_ticket_id" tabField="status" tabs={tabs} fieldsToSearch={["Customer", "Wig ID", "Ticket ID"]} additionalActions={additionalActions} />
  );
};

export default RepairTicketList;